import React from "react";
import { Row, Col, Skeleton } from "antd";
import { connectStateResults } from "react-instantsearch-dom";

import noProductsPng from "assets/images/noProducts.png";

const StateResults = ({ isSearchStalled, searchResults, Results, Cta }) => {
  const hasResults = searchResults && searchResults.nbHits !== 0;
  return (
    <>
      {isSearchStalled ? (
        <Skeleton active />
      ) : hasResults ? (
        Results
      ) : (
        <Row justify="center" style={{ marginTop: "20px" }}>
          <Col>
            <Row justify="center">
              <img
                src={noProductsPng}
                alt="success"
                width="386px"
                height="250px"
              />
            </Row>

            <Row justify="center">
              <div
                style={{
                  fontFamily: "Avenir",
                  fontSize: "18px",
                  fontWeight: "bolder",
                }}
              >
                We haven’t found any results for your search
              </div>
            </Row>
            <Row justify="center" style={{ marginTop: "1vh" }}>
              <div level={1} style={{ fontFamily: "Avenir", fontSize: "14px" }}>
                Try clearing some of the filters you have applied
              </div>
            </Row>
          </Col>
        </Row>
      )}
    </>
  );
};

const EmptyState = connectStateResults(StateResults);

export default EmptyState;
